import { Component, OnInit } from '@angular/core';
import { EAssetTypes } from '../../config/AssetsType';
import { AssetsService } from '../../services/assets.service';

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss']
})
export class AssetsComponent implements OnInit {

  public ErrorMsg: string;
  public error: boolean;

  public assetName: string;
  public assetType: string;
  public assetsType: any;
  public listOfAssets: Array<any>;
  public base64textString: string;
  public mimeType: string;
  file: File;
  assets: any = {
    songs: [],
    images: [],
    videos: [],
  };

  constructor(private assetsService: AssetsService) {
  }

  ngOnInit() {
    this.assets = {
      songs: [],
      images: [],
      videos: [],
    };
    this.listOfAssets = [];
    this.assetsType = EAssetTypes;
    this.assetsService.getAllAssets().then((assets) => {
      this.listOfAssets = assets;
      this.listOfAssets.forEach(asset => {
        if (asset.type === EAssetTypes.VIDEO) {
          this.assets.videos.push(asset);
        } else if (asset.type === EAssetTypes.IMAGE) {
          this.assets.images.push(asset);
        } else if (asset.type === EAssetTypes.AUDIO) {
          this.assets.songs.push(asset);
        }
      });
    });
  }

  addAsset() {
    if (this.assetName && this.base64textString && this.mimeType) {
      let fileExtension: string = null;
      if (this.file && this.file.name) {
        fileExtension = this.file.name.split('.').pop();
      }
      this.assetsService.addAsset(
        this.assetName, this.base64textString, this.mimeType, fileExtension).subscribe(() => { this.ngOnInit(); });
    }
  }

  delAsset(id) {
    this.assetsService.delAsset(id).subscribe(() => { this.ngOnInit(); });
  }

  handleFileSelect(evt) {
    this.file = evt.target.files[0];
    const myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      const matches = (<string>myReader.result).match(/^data:([A-Za-z0-9-+\/]+);base64,(.+)$/);
      this.mimeType = matches[1];
      this.base64textString = matches[2];
    };
    try {
      myReader.readAsDataURL(this.file);
    } catch (e) {
      this.base64textString = null;
      this.mimeType = null;
      this.file = null;
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/assets/assets.component.ts